// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"aff7a128","735":"0f482562","939":"81c344c6"}[chunkId] + ".chunk.css";
};